import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { CdnPathService } from '../services/cdn-path.service';

@Directive({
    selector: '[nwnCdnClient]',
    standalone: true,
})
export class CdnClientDirective implements OnInit {
    @Input('nwnCdnClient') public imagePath: string | undefined;
    @Input('fromBase') public fromBase: boolean = false;

    constructor(
        private readonly cdnPathService: CdnPathService,
        private readonly elementRef: ElementRef,
    ) {}

    ngOnInit(): void {
        this.elementRef.nativeElement.src = this.fromBase
            ? this.cdnPathService.imageUrlBase(this.imagePath)
            : this.cdnPathService.imageUrlClient(this.imagePath);
    }
}
